export default (store) => !store || store === 'pulpe' ? '' : `/${store}`